import { Injectable } from '@angular/core';
import { TreeviewI18n, TreeviewI18nDefault, TreeviewSelection } from 'ngx-treeview';

@Injectable()
export class TreeviewI18nCustom extends TreeviewI18n {
    
    getText(selection: TreeviewSelection): string {
        return TreeviewI18nDefault.prototype.getText(selection);
    }

    getAllCheckboxText(): string {
        return 'All';
    }

    getFilterPlaceholder(): string {
        return 'Filter';
    }

    getFilterNoItemsFoundText(): string {
        return 'Nessun elemento selezionabile';
    }
    
    getTooltipCollapseExpandText(isCollapse: boolean): string {
        return isCollapse ? 'Expand' : 'Collapse';
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/treeview/treeviewI18n-custom.ts